import * as yup from 'yup'

import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from 'reactstrap'
import { FaPencilAlt, FaSave, FaTrash } from 'react-icons/fa'
import React, { useState } from 'react'

import BuscadorTablas from 'components/Buscador/BuscadorTabla'
import PaginaPorDefecto from './Default'
import TarjetaContenido from 'components/TarjetaContenido/TarjetaContenido'
import { useEvidencia } from 'hooks/useEvidenciaCumplimiento'
import { useFormik } from 'formik'
import { useIndicador } from 'hooks/useIndicador'
import { useToggle } from 'hooks/useToggle'
import uuid from 'uuid/v4'

const initialValues = {
  nombre: '',
  evidencia: '',
  indicador: '',
}

const evidenciaSchema = yup.object().shape({
  nombre: yup.string().required('Este campo es requerido'),
  evidencia: yup.string().required('Este campo es requerido'),
  indicador: yup.string().required('Este campo es requerido'),
})

export default function Evidencia() {
  const { open, onToggle } = useToggle()
  const [evidenciaEdit, setEvidenciaEdit] = useState(null)
  const [buscar, setBuscar] = useState('')
  const {
    obtenerEvidencias,
    handleEliminarEvidencia,
    handleActualizarEvidencia,
    handleCrearEvidencia,
    handleBuscarEvidencia,
  } = useEvidencia(onToggle)
  const { obtenerIndicadores } = useIndicador(onToggle)
  const { data: indicadores } = obtenerIndicadores(buscar)
  const { data: evidencias } = obtenerEvidencias(buscar)

  const { handleChange, values, handleSubmit, errors } = useFormik({
    enableReinitialize: true,
    validationSchema: evidenciaSchema,
    initialValues: {
      ...initialValues,
      ...evidenciaEdit,
    },
    onSubmit: (values, acciones) => {
      if (evidenciaEdit) {
        handleActualizarEvidencia({
          values,
          acciones,
          id: evidenciaEdit.id,
        })
        return
      }
      handleCrearEvidencia(values, acciones)
    },
  })

  const onClosedModal = () => setEvidenciaEdit(null)

  return (
    <PaginaPorDefecto titulo='Evidencia'>
      <Modal
        isOpen={open}
        toggle={onToggle}
        size='lg'
        unmountOnClose
        onClosed={onClosedModal}
      >
        <ModalHeader toggle={onToggle}>
          {evidenciaEdit ? 'Editar' : 'Crear'} Evidencia
        </ModalHeader>
        <ModalBody>
          <form className='form-horizontal col-xs-12' onSubmit={handleSubmit}>
            <FormGroup>
              <Label>Nombre</Label>
              <Input
                type='text'
                name='nombre'
                value={values.nombre}
                onChange={handleChange}
                placeholder='Ingrese nombre'
                invalid={!!errors.nombre}
              />
              <div className='invalid-feedback'>{errors.nombre}</div>
            </FormGroup>
            <FormGroup>
              <Label>Evidencias</Label>
              <Input
                type='text'
                name='evidencia'
                value={values.evidencia}
                onChange={handleChange}
                placeholder='Ingrese evidencia'
                invalid={!!errors.evidencia}
              />
              <div className='invalid-feedback'>{errors.evidencia}</div>
            </FormGroup>

            <FormGroup>
              <Label>Indicador</Label>
              <Input
                type='select'
                name='indicador'
                value={values.indicador}
                onChange={handleChange}
                placeholder='Ingrese indicador'
                invalid={!!errors.indicador}
              >
                <option value=''>Seleccione...</option>
                {indicadores?.results.map((indicador) => (
                  <option key={uuid()} value={indicador.id}>
                    {indicador.nombre}
                  </option>
                ))}
              </Input>
              <div className='invalid-feedback'>{errors.indicador}</div>
            </FormGroup>
            <div className='form-group'>
              <label
                className='col-md-12 control-label'
                htmlFor='singlebutton'
              ></label>
              <div className='col-md-12'>
                <Button type='submit' className='mb-3' color='primary'>
                  {evidenciaEdit ? 'Editar' : 'Guardar'}
                </Button>
              </div>
            </div>
          </form>
        </ModalBody>
      </Modal>

      <TarjetaContenido
        titulo='Listar Evidencia Cumplimiento'
        component={
          <Button outline color='primary' onClick={onToggle}>
            <FaSave />
          </Button>
        }
      >
        <BuscadorTablas
          valor={buscar}
          onChange={setBuscar}
          onBuscar={handleBuscarEvidencia}
        />
        {evidencias ? (
          <Table responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Nombre</th>
                <th>Evidencias</th>
                <th>Indicador</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {evidencias.results.map((evidencia, index) => (
                <tr key={uuid()}>
                  <th scope='row'>{index + 1}</th>
                  <td>{evidencia.nombre}</td>
                  <td>{evidencia.evidencia}</td>
                  <td>{evidencia.indicador__nombre}</td>
                  <td className='d-flex'>
                    <Button
                      outline
                      color='primary'
                      size='sm'
                      className='mr-1'
                      onClick={() => {
                        setEvidenciaEdit(evidencia)
                        onToggle()
                      }}
                    >
                      <FaPencilAlt />
                    </Button>{' '}
                    <Button
                      outline
                      color='danger'
                      size='sm'
                      onClick={() => handleEliminarEvidencia(evidencia)}
                    >
                      <FaTrash />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div>Loading...</div>
        )}
      </TarjetaContenido>
    </PaginaPorDefecto>
  )
}
